var exports = {
  "CB": "RoleManagement.module__roleIndicator___ci13Ym",
  "KG": "RoleManagement.module__roleBadge___ci13Ym",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___ci13Ym",
  "j1": "RoleManagement.module__roleRemoveButton___ci13Ym",
  "r4": "RoleManagement.module__roleRemoveIconContainer___ci13Ym",
  "S3": "RoleManagement.module__roleName___ci13Ym",
  "MR": "RoleManagement.module__roleListContainer___ci13Ym",
  "ek": "RoleManagement.module__assignRoleButton___ci13Ym",
  "JO": "RoleManagement.module__assignRoleButtonIcon___ci13Ym",
  "RK": "RoleManagement.module__iconSize___ci13Ym",
  "Xk": "RoleManagement.module__noRolesLink___ci13Ym",
  "X9": "RoleManagement.module__roleColorIndicator___ci13Ym",
};

module.exports = exports;
